import http from './index'

export default {
  /*
   * 获取导航配置
   * */
  query (params) {
    return http.get('/front/navigate', params)
  },
  /*
   * 设置导航配置
   * */
  set (params) {
    return http.post('/front/navigate/save', params)
  }
}
